import * as React from 'react'
import { default as MuiSnackbar, SnackbarProps } from '@mui/material/Snackbar'

export const Snackbar = (props: SnackbarProps) => {
  return <MuiSnackbar {...props} />
}

export default Snackbar
